export const simpleNoteCreateComputed = {
  currency() {
    return String(this.noteInfo?.currency || 'MXN').trim().toUpperCase() || 'MXN';
  },
  subtotal() {
    return this.concepts.reduce((sum, concept) => {
      const qty = Number(concept?.qty || 0) || 0;
      const unitPrice = Number(concept?.unitPrice || 0) || 0;
      return sum + (qty * unitPrice);
    }, 0);
  },
  total() {
    return this.subtotal;
  },
  editingConceptData() {
    if (!Number.isInteger(this.editingConceptIndex) || this.editingConceptIndex < 0) {
      return null;
    }

    const concept = this.concepts[this.editingConceptIndex] || null;
    if (!concept || typeof concept !== 'object') {
      return null;
    }

    return {
      ...concept,
      paymentId: Number(concept?.paymentId || concept?.payment_id || 0) || 0,
      saleId: Number(concept?.saleId || concept?.sale_id || 0) || 0,
    };
  },
};
